import { useFeatureIsOn } from '@growthbook/growthbook-react';

/*
  IMPORTANT NOTICE
  When cleaning up a feature flag, make sure the feature flag is not deleted from Growthbook until the cleanup code has been deployed for at least two weeks.
  This is to ensure prod is not broken incase of a rollback.
*/

export const useTeamAccountsFeature = (): boolean | null => {
  return useFeatureIsOn('team-accounts');
};

export const useKittlBasicsTemplateEnabled = (): boolean => {
  return useFeatureIsOn('kittl-basics-template-enabled');
};

export const useNewTemplateSearch = (): boolean => {
  return useFeatureIsOn('new-template-search');
};

// Remove by https://app.clickup.com/t/86c11017q
export const useEditorAndDashboardUpdateFeature = (): boolean =>
  useFeatureIsOn('editor-and-dashboard-update');

export const useShowLikeIcon = (): boolean => {
  return useFeatureIsOn('show-like-icon');
};

// Remove by https://app.clickup.com/t/86c2dvyje
export const useTemplatePageRedesign = (): boolean =>
  useFeatureIsOn('template-page-redesign');

// Remove by https://app.clickup.com/t/86c39mk10
export const useSeoTemplatePageRedesign = (): boolean =>
  useFeatureIsOn('new-seo-templates-feed');

export const useDashboardTileImprovements = (): boolean => {
  return useFeatureIsOn('dashboard-tile-improvements');
};

export const useCollabShareFromWebsite = (): boolean =>
  useFeatureIsOn('collab-share-from-website');

export const useSharedWithMeEmptyState = (): boolean => {
  return useFeatureIsOn('shared-with-me-empty-state');
};

export const useWorkspacesFeatureEnabled = (): boolean =>
  useFeatureIsOn('workspaces');

export const useWorkspaceMenuReworkEnabled = (): boolean =>
  useFeatureIsOn('workspace-menu-rework');

export const useForYouSectionInHouseLogic = (): boolean =>
  useFeatureIsOn('for-you-section-in-house-logic');

export const useForYouSectionAwsPersonalize = (): boolean =>
  useFeatureIsOn('for-you-section-aws-personalize');

//Remove by https://app.clickup.com/t/86c34dxxd
export const useHomePageV2Enabled = (): boolean =>
  useFeatureIsOn('home-page-v2');

// TODO: Remove with https://app.clickup.com/t/86c39t0gr
export const useRelatedTemplatesSemanticEnabled = (): boolean =>
  useFeatureIsOn('related-templates-semantic');
